const capabilities = [
  { icon: 'ri-flashlight-line', text: 'Captures and responds to every lead instantly' },
  { icon: 'ri-repeat-line', text: 'Automates follow-ups across all channels' },
  { icon: 'ri-database-line', text: 'Centralizes your data into one unified system' },
  { icon: 'ri-bar-chart-line', text: 'Gives you real-time visibility into performance' },
];

export default function Solution() {
  return (
    <section id="solution" className="bg-[#0c0e24] py-24 md:py-32 relative overflow-hidden">
      {/* Subtle glow */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full bg-indigo-600/6 blur-3xl pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-6 md:px-10 relative z-10">
        {/* Top: Asymmetric title */}
        <div className="flex flex-col lg:flex-row items-start gap-8 lg:gap-16 mb-16 md:mb-20">
          <div className="flex-1">
            <div className="inline-flex items-center gap-2 bg-violet-500/10 border border-violet-500/20 rounded-full px-4 py-1.5 mb-6">
              <span className="w-2 h-2 rounded-full bg-violet-400 flex-shrink-0"></span>
              <span className="text-violet-300 text-xs font-medium tracking-widest uppercase whitespace-nowrap">The Solution</span>
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
              One System.<br />
              <span className="italic font-light text-white/30">Total Visibility.</span><br />
              Full Control.
            </h2>
          </div>
          <div className="flex-1 lg:pt-16">
            <p className="text-white/55 text-base md:text-lg leading-relaxed mb-8">
              We design and deploy AI-powered infrastructure that eliminates the gaps in your business — not by adding more tools, but by building a unified operational backbone.
            </p>
            <p className="text-white/80 font-semibold text-base">
              This is not another tool.<br />
              <span className="bg-gradient-to-r from-violet-400 to-indigo-300 bg-clip-text text-transparent">This is your operational backbone.</span>
            </p>
          </div>
        </div>

        {/* Capabilities list */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-16">
          {capabilities.map((c, i) => (
            <div
              key={i}
              className="flex items-center gap-4 bg-white/3 border border-white/8 rounded-2xl px-6 py-5 hover:border-violet-500/30 transition-all"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-violet-500/10 flex-shrink-0">
                <i className={`${c.icon} text-violet-400 text-lg`}></i>
              </div>
              <p className="text-white/70 text-sm font-medium">{c.text}</p>
            </div>
          ))}
        </div>

        {/* Visual: System diagram */}
        <div className="relative rounded-3xl overflow-hidden h-64 md:h-80">
          <img
            src="https://public.readdy.ai/ai/img_res/08998cd75f65e808349ba837e6e35179.jpg"
            alt="Unified system visualization"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0c0e24]/80 via-transparent to-[#0c0e24]/80"></div>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="text-center">
              <p className="text-white/30 text-xs tracking-widest uppercase mb-2">Your Unified System</p>
              <p className="text-white font-bold text-2xl md:text-3xl">Everything. Connected.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
